import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { UserRole } from '../../models/user-role';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../services/auth/session.service';
import { FormsService } from 'src/app/core/services/forms/forms.service';
import { RoleGroup, roleGroupDescription } from '../../types/auth/role-group';
import { Session } from '../../models/auth/session';

@Component({
  selector: 'tcat-switch-role-popup',
  templateUrl: './switch-role-popup.component.html',
  styleUrls: ['./switch-role-popup.component.scss']
})
export class SwitchRolePopupComponent implements OnInit {

  subsink = new SubSink();
  isShowing = false;
  resolveFn : any;
  rejectFn : any;
  roleOptions : {code: string, description: string}[] = [];
  loggedInUserRole?: RoleGroup;
  userRole?: RoleGroup;
  session?: Session;

  constructor(private fb: FormBuilder,
    private formsService: FormsService,
    private sessionService: SessionService) { }

  selectConfig = { key: 'code', description: 'description' };

  roleForm = this.fb.group(
    {
      newRole: [
        '',
        {
          validators: [Validators.required],
          updateOn: 'change'
        }
      ],
    },
    {}
  );

  ngOnInit() {
   this.subsink.sink =  this.sessionService.session()
      .subscribe(session => {
        if (session) {
          this.session = session;
          this.loggedInUserRole = (session.roles && session.roles.length > 0) ? session.roles[0] : undefined;
        }
      });
  }

  get newRole(): AbstractControl | null{
    return this.roleForm == null ? null : this.roleForm.get('newRole');
  }

  suppress(event: any) {
    event.stopPropagation();
  }

  show() {
    this.isShowing = true;
    this.reset();
  }

  hide() {
    this.isShowing = false;
  }

  cancel() {
    this.rejectFn();
    this.hide();
  }

  showPopup(): Promise<any> {
    this.userRole = this.session?.activeRole;
    this.roleOptions = this.session?.roles?.map(item => {
      return { code: item, description: roleGroupDescription(item) };
    }) ?? [];
    this.newRole?.setValue(this.userRole);
    this.show();
    return new Promise((resolve, reject) => {
      this.resolveFn = resolve;
      this.rejectFn = reject;
    });
  }

  reset() {
    this.newRole?.setValue(this.userRole);
  }

  submitRoleForm() {
    const newRole = this.newRole?.value;
    this.resolveFn(newRole);
    this.hide();
  }

  ngOnDestroy() {
   this.subsink.unsubscribe();
  }


}
